import { render, staticRenderFns } from "./products-compositions-inquiry.vue?vue&type=template&id=6e6b3b4f&"
import script from "./products-compositions-inquiry.vue?vue&type=script&lang=js&"
export * from "./products-compositions-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports